import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import { DeviceTesterContextProvider } from "../components/device-tester-context-provider/DeviceTesterContextProvider";
import { DeviceTester } from "../components/device-tester/DeviceTester";
import { GenericErrorPage } from "../components/error-page/GenericErrorPage";
import { MainLayout } from "../layout/MainLayout/MainLayout";
import { ResponsiveWrapper } from "../responsive/ResponsiveWrapper";
import { ErrorPages } from "../types/Device.types";
import { Paths } from "../types/paths";

export const RouteSwitcher = (): JSX.Element => {
  const { t } = useTranslation();
  const Home = () => {
    document.title = t("Device Test");
    return (
      <ResponsiveWrapper>
        <MainLayout>
          <DeviceTesterContextProvider>
            <DeviceTester />
          </DeviceTesterContextProvider>
        </MainLayout>
      </ResponsiveWrapper>
    );
  };
  const Timeout = () => {
    document.title = t("Device Test");
    return <GenericErrorPage errorPage={ErrorPages.SessionTimeout} />;
  };
  const BrowserError = () => {
    document.title = t("Device Test");
    return <GenericErrorPage errorPage={ErrorPages.BrowserNotSupported} />;
  };
  const AcsCallError = () => {
    document.title = t("Device Test");
    return <GenericErrorPage errorPage={ErrorPages.AcsCallError} />;
  };
  const Error = () => {
    document.title = t("Device Test");
    return <GenericErrorPage />;
  };

  return (
    <Routes>
      <Route path={Paths.Timeout} element={<Timeout />} />
      <Route path={Paths.BrowserError} element={<BrowserError />} />
      <Route path={Paths.AcsCallError} element={<AcsCallError />} />
      <Route path={Paths.Error} element={<Error />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};
